import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross Blue Shield of Wyoming",
  shortName: "BCBS Wyoming",
  slug: "bcbswy-insurance",
  seoTitle:
    "Blue Cross Blue Shield of Wyoming TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross Blue Shield of Wyoming policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBS Wyoming TMS coverage, Blue Cross Blue Shield Wyoming SPRAVATO authorization, BCBSWY mental health benefits Coral Springs FL, BCBS Wyoming depression treatment Florida",
};

export const BcbswyInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbswyInsurance;
